import axios from "axios";

const apiKey = process.env.REACT_APP_LOGGING_API_KEY;

if (!apiKey)
    throw new Error('The REACT_APP_LOGGING_API_KEY environment variable was not configured!');

const { protocol, host } = window.location;
const baseURL = `${protocol}//${host}`;

const api = axios.create({
    baseURL,
    headers: {
        'api-key': apiKey
    }
});

const logError = async (payload: object, err: unknown): Promise<boolean> => {
    try {
        await api.post<void>('logging', {
            payload,
            exception: err
        });
        return true;
    } catch (err) {
        return false;
    }
};

export { logError };